import { ColorFrom, DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import { IBorderInfo } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import { AngleFrom, ColorOperations, NumberInputFrom } from '@tencent/wb-ext-form';
import type { IColorProps } from '@framework/workbench/drawer/ui/border/border-feature';
import { IDirection, IFillGradualValues } from '@framework/workbench/drawer/ui/text/fill/fill-interface';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface IBorderFeature extends IBaseDrawerFeature {
    borderSolidValues: ITDColor;
    borderGradualValues: IFillGradualValues;
    borderSolidValuesPreview?: IBorderInfo;
    width: number;
    style: string;
    renderBorderLine(): ReactElement;
    renderGradualFill(): ReactElement;
    getCheckedFillType(): string;
    handleBorderTypeChange(value: string): void;
    handleBorderWidthChange(value: number): void;
    handleColorChange(props: IColorProps): void;
    changeBorderColor(value: ITDColor, from: ColorFrom, mouseMoveType?: ColorOperations): void;
    getOpacityFromColor(): number;
    handleOpacityChange(value: number, dragEnd: boolean, from: NumberInputFrom): void;
    handleGradualTypeChange(type: string): void;
    handleGradualAngleChange(value: number, from?: AngleFrom, dragEnd?: boolean): void;
    handleGradualDirectionChange(value: IDirection): void
    handleGradualOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void;
    getFillDirectionOptions();
    shouldAngleDisabled(): boolean;
    getColorSelectButton(): JSX.Element;
    renderBorderContent(): ReactElement | null;
    renderGradualDirection(): ReactElement | null;
}

export const IBorderFeature = Symbol.for('feature:drawer-font-border');

DynamicLoaderRegistry.merge(IBorderFeature, {
    useFactory: async () => {
        const { BorderFeature } = await import('./border-feature');
        return BorderFeature;
    },
    on: loadTask,
});
